export const HOME_NEW_STORAGE = {
  sidebar: 'syncscrm.home-new.sidebar',
  density: 'syncscrm.home-new.density',
};

export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

export const formatShortDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
  }).format(date);
};

export const getDaysSinceUpdate = (value) => {
  if (!value) return 0;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 0;
  return Math.max(0, Math.floor((Date.now() - date.getTime()) / 86400000));
};

export const getCardDocumentSummary = (card) => {
  const parts = [];
  if (card.second_document_number) parts.push(`Gest: ${card.second_document_number}`);
  if (card.pedido_number) parts.push(`Faktory: ${card.pedido_number}`);
  if (!parts.length && card.document_number) parts.push(`PrefWeb: ${card.document_number}`);
  return parts.join(' / ') || 'Sem número de documento';
};

export const getCardLocation = (card) =>
  card.cidade_estado_internacional || [card.city, card.state].filter(Boolean).join(', ') || 'Local não informado';

export const getInitials = (name) =>
  String(name || 'Syncs')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

export const getStatusTone = (card) => {
  if (card.status === 'Vendido') return 'success';
  if (card.status === 'Perdido') return 'danger';
  if (card.block_column) return 'locked';
  if (Number(card.temperatura_card) === 3) return 'hot';
  return 'default';
};

export const ATTACHMENT_CATEGORIES = [
  'Proposta Comercial',
  'Proposta Comercial Alterada',
  'Proposta Comercial Analise técnica',
  'Check List a ser preenchido',
  'Check List Medição',
  'Check List Medição Alterado',
  'Contrato Assinado',
  'Contrato Não Assinado',
  'Adiantamento Assinado',
  'Adiantamento Não Assinado',
  'Projeto da Obra',
  'Sistema construtivo - Projeto executivo de modulação',
  'Sistema construtivo - Produção',
  'Termo de Medição Assinado',
  'Termo de Medição Não Assinado',
  'Mapa de Corte',
  'Check List de Instalação',
  'CNO',
  'Fotos da obra',
  'Observações pós medição',
  'Aprovação cliente',
  'Alteração Interna de Pedido',
];
